import React, { useEffect, useState } from 'react';
import { useUI, useAuth, useData, useActions } from '../../context/AppContext';
import { filterMyStudents } from '../../utils/studentLogic';
import Modal from '../ui/Modal';
import TwoStepConfirmModal from '../ui/TwoStepConfirmModal';
import WorkoutProgramForm from '../forms/WorkoutProgramForm';
import SwimmingRecordForm from '../forms/SwimmingRecordForm';
import OgrenciEkleModal from './OgrenciEkleModal';
import OgrenciCikarModal from './OgrenciCikarModal';
import HizliGorevModal from './HizliGorevModal';
import ProfilDuzenleModal from './ProfilDuzenleModal';
import PaymentArchiveModal from '../payments/PaymentArchiveModal';
import TumOgrencilerModal from '../instructor/TumOgrencilerModal';

const STUDENT_MODALS = new Set([
  'newProgram', 'newRecord', 'deleteConfirm',
]);

const ModalRenderers = () => {
  const {
    activeModal, setActiveModal,
    selectedStudent,
    showToast,
    setPaymentPeriod,
    goToInstructorTab,
    goToInstructorStudent,
  } = useUI();
  const { loggedInUser, handleDeleteAccountPermanently } = useAuth();
  const { students } = useData();
  const { updateStudentData, updateInstructorData } = useActions();

  const myStudents = filterMyStudents(students, loggedInUser);
  const [isDeletingAccount, setIsDeletingAccount] = useState(false);
  const seciliOgrenci = selectedStudent
    ? students.find((s) => s.id === selectedStudent.id) || selectedStudent
    : null;

  const kapat = () => setActiveModal(null);

  useEffect(() => {
    if (!selectedStudent && activeModal && STUDENT_MODALS.has(activeModal)) {
      setActiveModal(null);
      showToast('Öğrenci seçimi kaldırıldı, lütfen tekrar deneyin.', 'error');
    }
  }, [selectedStudent, activeModal, setActiveModal, showToast]);

  return (
    <>
      <OgrenciEkleModal
        isOpen={activeModal === 'addStudent'}
        onClose={kapat}
        loggedInUser={loggedInUser}
        showToast={showToast}
      />

      {seciliOgrenci && (
        <>
          <Modal title="Bireysel Antrenman Görevi Ekle" isOpen={activeModal === 'newProgram'} onClose={kapat}>
            <WorkoutProgramForm student={seciliOgrenci} onSuccess={kapat} />
          </Modal>
          <Modal title="Yüzme Derecesi Gir" isOpen={activeModal === 'newRecord'} onClose={kapat}>
            <SwimmingRecordForm student={seciliOgrenci} onSuccess={kapat} />
          </Modal>
          <OgrenciCikarModal
            isOpen={activeModal === 'deleteConfirm'}
            onClose={kapat}
            ogrenci={seciliOgrenci}
            loggedInUser={loggedInUser}
            showToast={showToast}
          />
        </>
      )}

      <HizliGorevModal
        isOpen={activeModal === 'scheduleNewProgram'}
        onClose={kapat}
        myStudents={myStudents}
        students={students}
        showToast={showToast}
      />

      <ProfilDuzenleModal
        isOpen={activeModal === 'editProfile'}
        onClose={kapat}
        loggedInUser={loggedInUser}
        updateStudentData={updateStudentData}
        updateInstructorData={updateInstructorData}
        showToast={showToast}
        setActiveModal={setActiveModal}
      />

      <TwoStepConfirmModal
        isOpen={activeModal === 'deleteAccountConfirm'}
        onClose={kapat}
        title="Hesabı Kalıcı Olarak Sil"
        step1Description="Hesabınızı sildiğinizde profiliniz ve kayıtlarınız kalıcı olarak kaldırılır; bu işlem geri alınamaz."
        step2Description="Son onay: hesabınızı kalıcı olarak silmek için tekrar onaylayın."
        confirmLabel="Evet, Kalıcı Sil"
        tone="danger"
        busy={isDeletingAccount}
        busyLabel="Siliniyor..."
        onConfirm={async () => {
          if (isDeletingAccount) return false;
          setIsDeletingAccount(true);
          try {
            await handleDeleteAccountPermanently();
            kapat();
          } finally {
            setIsDeletingAccount(false);
          }
        }}
      />

      <TumOgrencilerModal
        isOpen={activeModal === 'allStudents'}
        students={myStudents}
        onClose={kapat}
        onSelectStudent={(student) => {
          kapat();
          goToInstructorStudent(student.id);
        }}
      />

      <PaymentArchiveModal
        isOpen={activeModal === 'paymentArchive'}
        instructor={loggedInUser}
        showToast={showToast}
        onSelectPeriod={(period) => {
          setPaymentPeriod(period);
          goToInstructorTab('payments');
        }}
        onClose={kapat}
      />
    </>
  );
};

export default ModalRenderers;
